/** @format */

import './gb-radio-group.scss';

export function GbRadioGroupDirective() {
    return {
        restrict: 'E',
        require: {
            ngModel: '^',
        },
        link: function (scope, element, attrs, controllers, transcludeFn) {
            element.attr('role', 'radiogroup');
        },
    };
}
